import styled from 'styled-components';

interface DropDownNavBarProps {
  isOpen: boolean;
}

export const Container = styled.header<DropDownNavBarProps>`
  width: 100%;
  position: relative;
  display: inline-block;

  .dropdown-toggle {
    width: 100%;
    justify-content: space-between;
    font-size: 20px;
    background-color: transparent;
    border: none;
    color: ${(props) => (props.isOpen ? '#FFF5C0' : '#FFF')};
    display: flex;
    align-items: center;
  }

  .dropdown-menu {
    border-bottom: 2px ${({ theme }) => theme.colors.yellow_200};

    div {
      display: flex;
      padding: 10px;
      margin-left: 10px;

      span {
        font-size: 16px !important;
      }
    }
  }

  @media (max-width: 300px) {
    .dropdown-menu div {
      margin-left: 2px;
    }
  }
`;
